import { render, staticRenderFns } from "./Desempenho.vue?vue&type=template&id=23fc8fea&scoped=true"
import script from "./Desempenho.vue?vue&type=script&lang=js"
export * from "./Desempenho.vue?vue&type=script&lang=js"
import style0 from "./Desempenho.vue?vue&type=style&index=0&id=23fc8fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc8fea",
  null
  
)

export default component.exports